export const TERMINAL_TRAINING_RUN_STATUSES = [
	'TRAINED',
	'EXPORT_FAILED',
	'TRAIN_FAILED',
];
export const PREPARING_TRAINING_RUN_STATUSES = [
	'EXPORT_REQUESTED',
	'EXPORT_IN_PROGRESS',
];
export const ACTIVE_TRAINING_RUN_STATUSES = [
	'TRAIN_REQUESTED',
	'TRAINING',
];

const DATA_PREP_RETRY_BLOCKED_STATUSES = [
	...PREPARING_TRAINING_RUN_STATUSES,
	'DATA_PREPPED',
	...ACTIVE_TRAINING_RUN_STATUSES,
	'TRAINED',
];

export const normalizeStatusValue = (status = '') => {
	return String(status ?? '').trim().toLowerCase().replace(/_/g, ' ');
};

export const formatStatusLabel = (status) => {
	if (status === null || status === undefined || status === '') return '-';
	return String(status)
		.replace(/_/g, ' ')
		.toLowerCase()
		.replace(/\b\w/g, (char) => char.toUpperCase());
};

export const statusChipClass = (status = '') => {
	const normalized = normalizeStatusValue(status);
	if (
		['trained', 'deployed', 'active', 'completed', 'finished'].includes(
			normalized
		)
	) {
		return '!border !border-green-200 !bg-green-50 !text-green-700';
	}
	if (['failed', 'error'].includes(normalized)) {
		return '!border !border-red-200 !bg-red-50 !text-red-700';
	}
	if (['data prepped', 'ready'].includes(normalized)) {
		return '!border !border-teal-200 !bg-teal-50 !text-teal-700';
	}
	if (
		[
			'training',
			'pending',
			'queued',
			'in progress',
			'starting',
			'running',
		].includes(normalized) ||
		normalized.includes('requested') ||
		normalized.includes('progress')
	) {
		return '!border !border-yellow-200 !bg-yellow-50 !text-yellow-700';
	}
	return '!border !border-slate-200 !bg-slate-50 !text-slate-700';
};

export const canStartShapeModelTraining = (statusData) => {
	const trainingRunStatus = statusData?.trainingRunStatus;
	return (
		statusData?.canStartTraining === true &&
		(trainingRunStatus === 'DATA_PREPPED' ||
			(!trainingRunStatus &&
				normalizeStatusValue(statusData?.modelStatus) === 'data prepped'))
	);
};

export const canPrepareShapeModelTrainingData = (statusData) => {
	if (!statusData) return false;
	if (
		DATA_PREP_RETRY_BLOCKED_STATUSES.includes(
			statusData?.trainingRunStatus
		)
	) {
		return false;
	}
	return (
		statusData?.trainingRunStatus === 'EXPORT_FAILED' ||
		statusData?.canRetryDataPrep === true ||
		statusData?.canPrepareTrainingData === true
	);
};

export const getTrainingGuidance = (statusData) => {
	switch (statusData?.trainingRunStatus) {
		case 'EXPORT_REQUESTED':
		case 'EXPORT_IN_PROGRESS':
			return 'Training data preparation is in progress.';
		case 'DATA_PREPPED':
			return 'Training data is ready. You can start training now.';
		case 'TRAIN_REQUESTED':
			return 'The training server has been requested. Training will start shortly.';
		case 'TRAINING':
			return 'Training is in progress.';
		case 'TRAINED':
			return 'Training completed successfully.';
		case 'EXPORT_FAILED':
			return 'Training data preparation failed.';
		case 'TRAIN_FAILED':
			return 'Training failed.';
		default:
			return 'No active training request.';
	}
};

export const mappedChipClass = (mappingStatus) => {
	if (mappingStatus === 'CURRENT') {
		return '!border !border-green-200 !bg-green-50 !text-green-700';
	}
	if (mappingStatus === 'OTHER') {
		return '!border !border-yellow-200 !bg-yellow-50 !text-yellow-700';
	}
	return '!border !border-slate-200 !bg-slate-50 !text-slate-700';
};

export const getMappingStatus = (product) => {
	if (product?.mappingStatus) {
		return product.mappingStatus;
	}
	return product?.isMapped ? 'CURRENT' : 'UNMAPPED';
};

export const isProductMappedToOtherModel = (product) => {
	return getMappingStatus(product) === 'OTHER';
};

export const getMappingLabel = (product) => {
	const mappingStatus = getMappingStatus(product);
	if (mappingStatus === 'CURRENT') return 'This model';
	if (mappingStatus === 'OTHER') {
		return product?.mappedShapeModelName
			? `Other model: ${product.mappedShapeModelName}`
			: 'Other model';
	}
	return 'No';
};
